<template>
    <div v-if="user && userBalanceInfo !== undefined && Object.keys(userBalanceInfo).length" class="menu-user-balance">
        <div v-if="toolUserSettings.is_show_exposure" class="float-right user-balance px-2 my-3">
            {{ $t('menu.exposure') }}
            <br :class="[$vuetify.breakpoint.width < desktopWidth ? 'd-none d-sm-flex d-md-flex d-lg-flex d-xl-none' : '', 'd-flex d-sm-none']" />
            <span :class="[$vuetify.breakpoint.xs ? 'lh-1-1' : '', 'orangeText', 'bold']">
                {{ utils.getCurrencySymbol(user.currency) }}{{ utils.formatNumber(userBalanceInfo.exposure, 'money') }}
            </span>
        </div>
        <div v-if="toolUserSettings.is_show_balance" class="px-2 float-right user-balance my-3">
            {{ $t('menu.balance') }}
            <br :class="[$vuetify.breakpoint.width < desktopWidth ? 'd-none d-sm-flex d-md-flex d-lg-flex d-xl-none' : '', 'd-flex d-sm-none']" />
            <span :class="[$vuetify.breakpoint.xs ? 'lh-1-1' : 'pl-1', userBalanceInfo.balance < 0 ? 'redText' : 'greenText', '', 'bold']">
                {{ utils.getCurrencySymbol(user.currency) }}{{ utils.formatNumber(userBalanceInfo.balance, 'money') }}
            </span>
        </div>
        <div v-if="toolUserSettings.is_show_credit" :class="[$vuetify.breakpoint.width < 524 ? 'pl-0 pr-2' : 'px-2', 'float-right user-balance my-3']">
            {{ $t('menu.credit') }}
            <br :class="[$vuetify.breakpoint.width < desktopWidth ? 'd-none d-sm-flex d-md-flex d-lg-flex d-xl-none' : '', 'd-flex d-sm-none']" />
            <span :class="[$vuetify.breakpoint.xs ? 'lh-1-1' : '', $vuetify.theme.dark ? 'whiteText' : 'blackText', 'bold']">
                {{ utils.getCurrencySymbol(user.currency) }}{{ utils.formatNumber(userBalanceInfo.credit, 'money') }}
            </span>
        </div>
    </div>
</template>
<style scoped></style>
<script>
    export default {
        name: 'app-menuUserBalanceInfo',
        components: {},
        data() {
            return {};
        },

        created() {
            console.log('Component %s was created.', this.$options.name);
        },

        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },

        methods: {},

        computed: {
            userBalanceInfo: {
                get() {
                    return this.$store.getters['UserModule/getBalance'];
                },
            },
            toolUserSettings: {
                get() {
                    return this.$store.getters['AppModule/getToolUserSettings'];
                },
                set(value) {
                    this.$store.commit('AppModule/setToolUserSettings', value);
                },
            },
            user() {
                return this.$store.getters['UserModule/getUser'];
            },
            desktopWidth() {
                let desktopWidth = 1425;
                if (!this.toolUserSettings.is_show_exposure) {
                    desktopWidth = desktopWidth - 130;
                }
                if (!this.toolUserSettings.is_show_balance) {
                    desktopWidth = desktopWidth - 130;
                }
                if (!this.toolUserSettings.is_show_credit) {
                    desktopWidth = desktopWidth - 115;
                }
                return desktopWidth;
            },
        },
    };
</script>
